import React from 'react';
import styled from 'styled-components';

import { Tooltip } from 'components'

const Aux = styled.div`
    // width: 100%;
    height: 100%;
`

const Container = styled.div`
    min-height: 0.1rem;
    background-color: ${props => props.color ? props.color : 'var(--secondary-color)'};
    width: ${props => props.orientation === 'horizontal' && props.width ? props.width
            : props.orientation === 'horizontal' ? '100%' 
            : props.orientation === 'vertical' && props.width ? props.width 
            : '0.2rem'}; 
    height: ${props => props.orientation === 'vertical' && props.height ? props.height
            : props.orientation === 'vertical' ? '100%'
            : props.orientation === 'horizontal' && props.height ? props.height 
            : '0.2rem'};
    margin: ${props => props.margin ? props.margin : null};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    cursor: pointer;
`

const Bar = styled.div`
    min-height: 0.1rem;
    background-color: ${props => props.color ? props.color : 'var(--secondary-accent-color)'};
    width: ${props => props.orientation === 'horizontal' && props.percent ? props.percent 
            : props.orientation === 'horizontal' && !props.percent ? '0' 
            : props.orientation === 'vertical' && props.width ? props.width 
            : '0.2rem'}; 
    height: ${props => props.orientation === 'vertical' && props.percent ? props.percent 
            : props.orientation === 'vertical' && !props.percent ? '0' 
            : props.orientation === 'horizontal' && props.height ? props.height 
            : '0.2rem'};
    margin: ${props => props.margin ? props.margin : null};
    border-radius: 2px;
    display: flex;
    flex-direction: ${props => props.orientation === 'vertical' ? 'column' : 'row'};
    justify-content: flex-end;
    align-items: flex-end;
`

const Percent = styled.div`
    // border: 1px solid white;
    font-size: 0.8rem;
    color: var(--secondary-accent-color);
    display: inline-flex;
    padding-bottom: 0.3rem;
    position: relative;
    left: ${props => props.percent};
    transform: ${props => props.orientation === 'horizontal' ? `translateX(-50%)`
    : props.orientation === 'vertical' ? `translateY(-50%)`
    : null };

`

const Stat = styled.div`
    // border: 1px solid white;
    font-size: 0.8rem;
    color: var(--secondary-accent-color);
    display: flex;
    padding-top: 0.3rem;
    justify-content: flex-end;
`

const PercentBar = props => {
    const {
        orientation,
        percent,
        total,
        width,
        height,
        margin,
        primaryColor,
        secondaryColor,
        showPercentage,
        data,
        onSelect,
        ...other
    } = props;


    return (
        <Aux>
            {showPercentage ? <Percent orientation={orientation} percent={percent}>{total === 0 ? null : percent}</Percent> : null}
            {total === 0 ? null 
            : <Tooltip title={props.tooltip} arrow={true}>
                <Container orientation={orientation} width={width} height={height} margin={margin} color={primaryColor} onClick={onSelect}>
                    <Bar orientation={orientation} percent={percent} color={secondaryColor}
                        width={orientation === 'vertical' ? width : null} 
                        height={orientation === 'horizontal' ? height : null}
                        />
                </Container>
            </Tooltip>}
            {total ? <Stat orientation={orientation}>{total}</Stat> : null}
        </Aux>
    )
}

export default PercentBar;
